import { useContext } from 'react';
import ConfigContext from '@/contexts/ConfigContext';

export default ({
    children,
}) => {
    const configs = useContext(ConfigContext);

    return configs.site.adsEnabled && !configs.site.disableCLPAds && children;
};
